import { useState, useEffect } from 'react';
import api from '../api';
import stili from './competenze/stili';

const SECONDI_VISIBILE = 30;

// "Mostra password" di un account cliente: la password arriva solo in questa risposta (mai nell'elenco), resta solo nello stato di questa
// finestra e si nasconde da sola dopo 30 secondi o alla chiusura. Non finisce in nessun'altra parte dell'app.
export default function MostraPasswordCliente({ utenteId, etichetta, onChiudi }) {
  const [stato, setStato] = useState({ fase: 'carico' });
  const [secondi, setSecondi] = useState(SECONDI_VISIBILE);
  const [copiata, setCopiata] = useState(false);

  useEffect(() => {
    let vivo = true;
    api.post(`/account-clienti/${utenteId}/mostra-password`)
      .then(r => { if (vivo) setStato({ fase: 'ok', password: r.data.password }); })
      .catch(err => {
        if (!vivo) return;
        const d = err.response?.data || {};
        setStato({ fase: 'errore', messaggio: d.errore || 'Non è stato possibile mostrare la password', codice: d.codice });
      });
    return () => { vivo = false; };
  }, [utenteId]);

  useEffect(() => {
    if (stato.fase !== 'ok') return undefined;
    const t = setInterval(() => setSecondi(s => s - 1), 1000);
    return () => clearInterval(t);
  }, [stato.fase]);
  useEffect(() => { if (stato.fase === 'ok' && secondi <= 0) setStato({ fase: 'nascosta' }); }, [secondi, stato.fase]);

  const copia = async () => {
    try { await navigator.clipboard.writeText(stato.password); setCopiata(true); } catch { setCopiata(false); }
  };

  return (
    <div style={stili.overlay} role="dialog" aria-label="Password dell'account cliente">
      <div style={{ ...stili.modal, maxWidth: '460px' }}>
        <h3 style={{ marginTop: 0 }}>Password dell'account</h3>
        {etichetta && <p style={{ margin: '0 0 0.8rem', color: '#555', fontSize: '0.9rem' }}>{etichetta}</p>}
        {stato.fase === 'carico' && <p>Caricamento…</p>}
        {stato.fase === 'ok' && (
          <>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', flexWrap: 'wrap', margin: '0.6rem 0' }}>
              <code aria-label="Password" style={{ fontFamily: 'monospace', fontSize: '1.1rem', background: '#F7F7EA', padding: '0.3rem 0.6rem', borderRadius: '4px', letterSpacing: '0.05em', wordBreak: 'break-all' }}>{stato.password}</code>
              <button type="button" onClick={copia} style={stili.btnSmall}>{copiata ? 'Copiata' : 'Copia'}</button>
            </div>
            <div style={{ background: '#fff8e1', color: '#7a5b00', padding: '0.6rem', borderRadius: '6px', fontSize: '0.85rem' }}>
              Si nasconde da sola tra {Math.max(secondi, 0)} secondi. Comunicala solo al cliente. Questa visualizzazione è registrata.
            </div>
          </>
        )}
        {stato.fase === 'nascosta' && <p>Password nascosta per sicurezza. Chiudi e riapri per vederla di nuovo.</p>}
        {stato.fase === 'errore' && (
          <div role="alert" style={stili.errore}>
            {stato.codice === 'VISUALIZZAZIONE_NON_DISPONIBILE' ? 'Visualizzazione non disponibile.' : stato.messaggio}
            {stato.codice === 'VISUALIZZAZIONE_NON_DISPONIBILE' && ' Il login dei clienti funziona normalmente; per i dettagli vedi il README di deploy.'}
          </div>
        )}
        <div style={stili.azioni}><button type="button" onClick={onChiudi} style={stili.btn}>Chiudi</button></div>
      </div>
    </div>
  );
}
